import { ThunkDispatch } from "core-integration/src/store";
import { logout } from "core-integration/src/store/player/thunks";
import React, { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import {
  createCustomInteractionData,
  createInteractionData,
} from "../../utils/tealium";

const mapDispatch = {
  logout: () => logout(),
};

const connector = connect(null, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & WithTranslation;

const Logout: React.FC<Props> = ({ t }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  useEffect(() => {
    (async () => {
      await dispatch(logout())
        .then(() => {
          createInteractionData({
            contentTitle: "home",
            interactionId: "nba-fantasy-game:sign-out:cta",
            interactionText: t("navigation.signOut", "Sign out"),
          });
          window.location.replace("/");
        })
        .then(() => {
          const userData = { userState: "guest" };
          createCustomInteractionData({
            contentTitle: "home",
            interactionId: "fantasy:logout:success",
            userData,
            ampEventName: "User Account: Logout Success",
          });
        })
        .catch(() => {});
    })();
  }, []);

  return <div />;
};

export default connector(withTranslation()(Logout));
